import { createFetcher } from "api/helpers"
// import { zeroDayMockData } from "mocks/responses/securityResponses"

const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, projectId) => {
    return `${host}/security/${projectId}/get_zero_day_report`
  },
  checkRequiredArguments: () => {},
  makeResponseData: (json) => {
    return json
    // return zeroDayMockData
  }
}
export default createFetcher(fetcherConfiguration)
